<span *ngIf="data; else emptyTmpl" p500UITooltip [tooltipData]="data | timeAgo" style="white-space: nowrap">
  {{ data | date: 'dd/MM/yyyy HH:mm:ss':'UTC' }}
</span>
<ng-template #emptyTmpl>
  <gtd-ui-field-default-string-or-empty></gtd-ui-field-default-string-or-empty>
</ng-template>
